export const THEME_STORAGE_KEY = 'isabhel-theme-mode';
export const THEME_MODE_OPTIONS = ['light', 'dark', 'system'];
export const DEFAULT_THEME_MODE = 'system';

export function isValidThemeMode(value) {
    return THEME_MODE_OPTIONS.includes(value);
}

export function normalizeThemeMode(value) {
    return isValidThemeMode(value) ? value : DEFAULT_THEME_MODE;
}

export function resolveThemeMode(mode, prefersDark = false) {
    const normalizedMode = normalizeThemeMode(mode);
    if (normalizedMode === 'dark') return 'dark';
    if (normalizedMode === 'light') return 'light';
    return prefersDark ? 'dark' : 'light';
}

export function getStoredThemeMode(storage) {
    if (!storage?.getItem) return null;

    try {
        const rawValue = storage.getItem(THEME_STORAGE_KEY);
        return isValidThemeMode(rawValue) ? rawValue : null;
    } catch {
        return null;
    }
}

export function persistThemeMode(storage, mode) {
    const normalizedMode = normalizeThemeMode(mode);

    if (!storage?.setItem) {
        return normalizedMode;
    }

    try {
        storage.setItem(THEME_STORAGE_KEY, normalizedMode);
    } catch {
        // Ignore storage failures so theme switching still works in-memory.
    }

    return normalizedMode;
}

export function getSystemThemePreference(matchMedia) {
    if (typeof matchMedia !== 'function') {
        return false;
    }

    try {
        return Boolean(matchMedia('(prefers-color-scheme: dark)').matches);
    } catch {
        return false;
    }
}

export function getThemeColor(variableName, fallbackValue = '') {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return fallbackValue;
    }

    const value = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue(variableName)
        .trim();

    return value || fallbackValue;
}

export function getThemeBootstrapScript() {
    return `
        (function () {
            try {
                var storageKey = ${JSON.stringify(THEME_STORAGE_KEY)};
                var storedMode = localStorage.getItem(storageKey);
                var mode = (storedMode === 'light' || storedMode === 'dark' || storedMode === 'system')
                    ? storedMode
                    : 'system';
                var prefersDark = !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
                var resolvedMode = mode === 'dark' || (mode === 'system' && prefersDark) ? 'dark' : 'light';
                document.documentElement.dataset.theme = resolvedMode;
                document.documentElement.style.colorScheme = resolvedMode;
            } catch (error) {
                document.documentElement.dataset.theme = 'light';
                document.documentElement.style.colorScheme = 'light';
            }
        }());
    `;
}
